import React from 'react'

export const scrollToTop = (e?: React.SyntheticEvent) => {
  window.scrollTo(0, 0)
  if (e) e.preventDefault()
}
